import React, { useMemo, useState } from "react";
import {
  Box,
  Paper,
  Typography,
  IconButton,
  Popover,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

// ---- Dummy data (to be wired to APIs later) ------------------------------

const CASE_TYPE_COLORS = {
  Documentation: "#FF7A45",
  "Court appearance": "#2F5BEA",
  Appointment: "#2FAE6B",
  // "Documentation": "#8A4FE0",
  // Appointment: "#00A19A",
};

// key = yyyy-mm-dd
const eventsByDate = {
  "2025-05-01": [
    {
      time: "11:00 AM",
      title: "CS/210/2024",
      client: "ABC Pvt. Ltd.",
      respondent: "N/A",
      court: "N/A",
      description: "Preparation and filing of case related documents.",
      type: "Documentation",
    },
  ],
  "2025-05-05": [
    {
      time: "10:00 AM",
      title: "CS/245/2024",
      client: "ABC Pvt. Ltd.",
      respondent: "N/A",
      court: "N/A",
      description: "Preparation and filing of case related documents.",
      type: "Documentation",
    },
    {
      time: "03:00 PM",
      title: "ARB/12/2024",
      client: "Sunrise Infra Ltd.",
      respondent: "Coastal Builders Pvt. Ltd.",
      court: "Arbitration Tribunal, Mumbai",
      description: "Scheduled hearing before the arbitration tribunal.",
      type: "Court appearance",
    },
  ],
  "2025-05-06": [
    {
      time: "11:30 AM",
      title: "ARB/18/2024",
      client: "Sunrise Infra Ltd.",
      respondent: "Coastal Builders Pvt. Ltd.",
      court: "Arbitration Tribunal, Mumbai",
      description: "Scheduled hearing before the arbitration tribunal.",
      type: "Court appearance",
    },
  ],
  "2025-05-07": [
    {
      time: "09:30 AM",
      title: "CR/288/2023",
      client: "Rajesh Kumar",
      respondent: "N/A",
      court: "N/A",
      description: "Client meeting to discuss case progress and next steps.",
      type: "Appointment",
    },
    {
      time: "01:00 PM",
      title: "RERA/109/2024",
      client: "XYZ Developers",
      respondent: "N/A",
      court: "N/A",
      description: "Preparation and filing of case related documents.",
      type: "Documentation",
    },
  ],
  "2025-05-08": [
    {
      time: "10:00 AM",
      title: "CS/245/2024",
      client: "ABC Pvt. Ltd.",
      respondent: "N/A",
      court: "N/A",
      description: "Preparation and filing of case related documents.",
      type: "Documentation",
    },
    {
      time: "11:30 AM",
      title: "ARB/18/2024",
      client: "Sunrise Infra Ltd.",
      respondent: "Coastal Builders Pvt. Ltd.",
      court: "Arbitration Tribunal, Mumbai",
      description: "Scheduled hearing before the arbitration tribunal.",
      type: "Court appearance",
    },
    {
      time: "02:00 PM",
      title: "CR/302/2023",
      client: "Rajesh Kumar",
      respondent: "N/A",
      court: "N/A",
      description: "Client meeting to discuss case progress and next steps.",
      type: "Appointment",
    },
    {
      time: "04:00 PM",
      title: "RERA/112/2024",
      client: "XYZ Developers",
      respondent: "N/A",
      court: "N/A",
      description: "Preparation and filing of case related documents.",
      type: "Documentation",
    },
    {
      time: "05:30 PM",
      title: "CS/678/2024",
      client: "Global Tech Ltd.",
      respondent: "N/A",
      court: "N/A",
      description: "Client meeting to discuss case progress and next steps.",
      type: "Appointment",
    },
  ],
  "2025-05-09": [
    {
      time: "12:00 PM",
      title: "CS/690/2024",
      client: "Global Tech Ltd.",
      respondent: "N/A",
      court: "N/A",
      description: "Client meeting to discuss case progress and next steps.",
      type: "Appointment",
    },
  ],
  "2025-05-12": [
    {
      time: "10:30 AM",
      title: "ARB/20/2024",
      client: "Sunrise Infra Ltd.",
      respondent: "Coastal Builders Pvt. Ltd.",
      court: "Arbitration Tribunal, Mumbai",
      description: "Scheduled hearing before the arbitration tribunal.",
      type: "Court appearance",
    },
    {
      time: "02:30 PM",
      title: "CR/305/2023",
      client: "Rajesh Kumar",
      respondent: "N/A",
      court: "N/A",
      description: "Client meeting to discuss case progress and next steps.",
      type: "Appointment",
    },
  ],
  "2025-05-14": [
    {
      time: "11:00 AM",
      title: "RERA/115/2024",
      client: "XYZ Developers",
      respondent: "N/A",
      court: "N/A",
      description: "Preparation and filing of case related documents.",
      type: "Documentation",
    },
  ],
  "2025-05-16": [
    {
      time: "09:00 AM",
      title: "CS/701/2024",
      client: "Global Tech Ltd.",
      respondent: "N/A",
      court: "N/A",
      description: "Client meeting to discuss case progress and next steps.",
      type: "Appointment",
    },
    {
      time: "03:30 PM",
      title: "CS/260/2024",
      client: "ABC Pvt. Ltd.",
      respondent: "N/A",
      court: "N/A",
      description: "Preparation and filing of case related documents.",
      type: "Documentation",
    },
  ],
  "2025-05-20": [
    {
      time: "10:00 AM",
      title: "ARB/22/2024",
      client: "Sunrise Infra Ltd.",
      respondent: "Coastal Builders Pvt. Ltd.",
      court: "Arbitration Tribunal, Mumbai",
      description: "Scheduled hearing before the arbitration tribunal.",
      type: "Court appearance",
    },
  ],
  "2025-05-22": [
    {
      time: "01:30 PM",
      title: "CR/310/2023",
      client: "Rajesh Kumar",
      respondent: "N/A",
      court: "N/A",
      description: "Client meeting to discuss case progress and next steps.",
      type: "Appointment",
    },
    {
      time: "04:00 PM",
      title: "RERA/118/2024",
      client: "XYZ Developers",
      respondent: "N/A",
      court: "N/A",
      description: "Preparation and filing of case related documents.",
      type: "Documentation",
    },
  ],
  "2025-05-27": [
    {
      time: "11:00 AM",
      title: "CS/712/2024",
      client: "Global Tech Ltd.",
      respondent: "N/A",
      court: "N/A",
      description: "Client meeting to discuss case progress and next steps.",
      type: "Appointment",
    },
  ],
  "2025-05-29": [
    {
      time: "09:30 AM",
      title: "CS/265/2024",
      client: "ABC Pvt. Ltd.",
      respondent: "N/A",
      court: "N/A",
      description: "Preparation and filing of case related documents.",
      type: "Documentation",
    },
    {
      time: "12:00 PM",
      title: "ARB/25/2024",
      client: "Sunrise Infra Ltd.",
      respondent: "Coastal Builders Pvt. Ltd.",
      court: "Arbitration Tribunal, Mumbai",
      description: "Scheduled hearing before the arbitration tribunal.",
      type: "Court appearance",
    },
    {
      time: "02:00 PM",
      title: "CR/315/2023",
      client: "Rajesh Kumar",
      respondent: "N/A",
      court: "N/A",
      description: "Client meeting to discuss case progress and next steps.",
      type: "Appointment",
    },
  ],
};

const WEEKDAY_LABELS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const MAX_EVENTS_PER_CELL = 3;

// ---- Helpers --------------------------------------------------------------

function formatKey(date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
    2,
    "0",
  )}-${String(date.getDate()).padStart(2, "0")}`;
}

function isSameDay(a, b) {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
}

function buildMonthMatrix(anchorDate) {
  const year = anchorDate.getFullYear();
  const month = anchorDate.getMonth();
  const firstDay = new Date(year, month, 1);
  const startWeekday = firstDay.getDay();
  const totalDaysInMonth = new Date(year, month + 1, 0).getDate();
  const prevMonthTotalDays = new Date(year, month, 0).getDate();

  const cells = [];
  for (let i = startWeekday - 1; i >= 0; i--) {
    cells.push({
      date: new Date(year, month - 1, prevMonthTotalDays - i),
      inMonth: false,
    });
  }
  for (let d = 1; d <= totalDaysInMonth; d++) {
    cells.push({ date: new Date(year, month, d), inMonth: true });
  }
  let nextDay = 1;
  while (cells.length < 42) {
    cells.push({ date: new Date(year, month + 1, nextDay), inMonth: false });
    nextDay++;
  }

  const weeks = [];
  for (let i = 0; i < 42; i += 7) {
    weeks.push(cells.slice(i, i + 7));
  }
  return weeks;
}

function buildWeekDays(anchorDate) {
  const start = new Date(anchorDate);
  start.setDate(start.getDate() - start.getDay());
  return Array.from({ length: 7 }, (_, i) => {
    const date = new Date(start);
    date.setDate(start.getDate() + i);
    return { date, inMonth: true };
  });
}

// ---- Component --------------------------------------------------------------

export default function LegalCalendar() {
  const [view, setView] = useState("week");
  const [anchorDate, setAnchorDate] = useState(new Date(2025, 4, 1));
  const [popoverAnchor, setPopoverAnchor] = useState(null);
  const [popoverCell, setPopoverCell] = useState(null);
  const [selectedEvent, setSelectedEvent] = useState(null);

  const today = useMemo(() => new Date(), []);
  const weeks = useMemo(() => buildMonthMatrix(anchorDate), [anchorDate]);
  const weekDays = useMemo(() => buildWeekDays(anchorDate), [anchorDate]);

  const monthLabel = anchorDate.toLocaleDateString("en-US", {
    month: "long",
    year: "numeric",
  });
  const weekRangeLabel = `${weekDays[0].date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
  })} - ${weekDays[6].date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  })}`;

  const handleViewChange = (e, next) => {
    if (next) setView(next);
  };

  const goToPrev = () =>
    setAnchorDate((d) =>
      view === "week"
        ? new Date(d.getFullYear(), d.getMonth(), d.getDate() - 7)
        : new Date(d.getFullYear(), d.getMonth() - 1, 1),
    );
  const goToNext = () =>
    setAnchorDate((d) =>
      view === "week"
        ? new Date(d.getFullYear(), d.getMonth(), d.getDate() + 7)
        : new Date(d.getFullYear(), d.getMonth() + 1, 1),
    );
  const goToToday = () =>
    setAnchorDate(
      view === "week"
        ? new Date(today.getFullYear(), today.getMonth(), today.getDate())
        : new Date(today.getFullYear(), today.getMonth(), 1),
    );

  const handleMoreClick = (e, cell, events) => {
    setPopoverAnchor(e.currentTarget);
    setPopoverCell({ cell, events });
  };
  const handlePopoverClose = () => {
    setPopoverAnchor(null);
    setPopoverCell(null);
  };

  const handleEventClick = (e, ev, cell) => {
    e.stopPropagation();
    setSelectedEvent({ ...ev, date: cell.date });
  };
  const handleEventDialogClose = () => setSelectedEvent(null);

  return (
    <Box sx={{ p: 1 }}>
      <Paper
        elevation={0}
        sx={{ p: 1, borderRadius: 1, border: "1px solid #ECEFF3" }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 1,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography sx={{ fontWeight: 600, fontSize: 17 }}>
              Legal Case Calendar
            </Typography>
            <Button
              size="small"
              variant="outlined"
              onClick={goToToday}
              sx={{ fontSize: 12, py: 0.15, minWidth: 0, px: 1 }}
            >
              Today
            </Button>
            <ToggleButtonGroup
              size="small"
              value={view}
              exclusive
              onChange={handleViewChange}
              sx={{
                "& .MuiToggleButton-root": {
                  fontSize: 12,
                  py: 0.15,
                  px: 1.2,
                  textTransform: "none",
                },
              }}
            >
              <ToggleButton value="month">Month</ToggleButton>
              <ToggleButton value="week">Week</ToggleButton>
            </ToggleButtonGroup>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            <IconButton size="small" onClick={goToPrev}>
              <ChevronLeftIcon fontSize="small" />
            </IconButton>
            <Typography
              sx={{
                fontSize: 15,
                fontWeight: 600,
                minWidth: 150,
                textAlign: "center",
              }}
            >
              {view === "month" ? monthLabel : weekRangeLabel}
            </Typography>
            <IconButton size="small" onClick={goToNext}>
              <ChevronRightIcon fontSize="small" />
            </IconButton>
          </Box>
        </Box>

        {/* Legend */}
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5, mb: 1 }}>
          {Object.entries(CASE_TYPE_COLORS).map(([label, color]) => (
            <Box
              key={label}
              sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
            >
              <Box
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  bgcolor: color,
                }}
              />
              <Typography sx={{ fontSize: 12, color: "text.secondary" }}>
                {label}
              </Typography>
            </Box>
          ))}
        </Box>

        {view === "month" ? (
          <>
            {/* Weekday header */}
            <Box
              sx={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)" }}
            >
              {WEEKDAY_LABELS.map((wd) => (
                <Box key={wd} sx={{ textAlign: "center", py: 0.5 }}>
                  <Typography
                    sx={{
                      fontSize: 12,
                      fontWeight: 600,
                      color: "text.secondary",
                    }}
                  >
                    {wd}
                  </Typography>
                </Box>
              ))}
            </Box>

            {/* Month grid */}
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(7, 1fr)",
                gridAutoRows: "1fr",
                border: "1px solid #ECEFF3",
                borderLeft: "none",
                borderTop: "none",
              }}
            >
              {weeks.flat().map((cell, i) => {
                const key = formatKey(cell.date);
                const events = eventsByDate[key] || [];
                const visibleEvents = events.slice(0, MAX_EVENTS_PER_CELL);
                const hiddenCount = events.length - visibleEvents.length;
                const isToday = isSameDay(cell.date, today);

                return (
                  <Box
                    key={i}
                    sx={{
                      minHeight: 92,
                      p: 0.5,
                      borderRight: "1px solid #ECEFF3",
                      borderBottom: "1px solid #ECEFF3",
                      bgcolor: cell.inMonth ? "#fff" : "#FAFBFC",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        mb: 0.25,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: 12,
                          fontWeight: isToday ? 700 : 500,
                          color: cell.inMonth
                            ? "text.primary"
                            : "text.disabled",
                          width: 20,
                          height: 20,
                          borderRadius: "50%",
                          textAlign: "center",
                          lineHeight: "20px",
                          bgcolor: isToday ? "primary.main" : "transparent",
                          ...(isToday && { color: "#fff" }),
                        }}
                      >
                        {cell.date.getDate()}
                      </Typography>
                    </Box>

                    {visibleEvents.map((ev, j) => (
                      <Box
                        key={j}
                        onClick={(e) => handleEventClick(e, ev, cell)}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 0.4,
                          mb: 0.25,
                          px: 0.4,
                          py: 0.1,
                          borderRadius: 0.5,
                          bgcolor: `${CASE_TYPE_COLORS[ev.type]}1A`,
                          overflow: "hidden",
                          cursor: "pointer",
                        }}
                        title={`${ev.time} - ${ev.title} (${ev.client})`}
                      >
                        <Box
                          sx={{
                            width: 5,
                            height: 5,
                            minWidth: 5,
                            borderRadius: "50%",
                            bgcolor: CASE_TYPE_COLORS[ev.type],
                          }}
                        />
                        <Typography
                          noWrap
                          sx={{
                            fontSize: 12,
                            color: "text.primary",
                            lineHeight: 1.3,
                          }}
                        >
                          {ev.time} {ev.title}
                        </Typography>
                      </Box>
                    ))}

                    {hiddenCount > 0 && (
                      <Typography
                        onClick={(e) => handleMoreClick(e, cell, events)}
                        sx={{
                          fontSize: 10.5,
                          color: "primary.main",
                          cursor: "pointer",
                          pl: 0.4,
                        }}
                      >
                        +{hiddenCount} more
                      </Typography>
                    )}
                  </Box>
                );
              })}
            </Box>
          </>
        ) : (
          /* Week grid */
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(7, 1fr)",
              border: "1px solid #ECEFF3",
              borderLeft: "none",
              borderTop: "none",
            }}
          >
            {weekDays.map((cell, i) => {
              const key = formatKey(cell.date);
              const events = eventsByDate[key] || [];
              const isToday = isSameDay(cell.date, today);

              return (
                <Box
                  key={i}
                  sx={{
                    minHeight: 420,
                    p: 0.75,
                    borderRight: "1px solid #ECEFF3",
                    borderBottom: "1px solid #ECEFF3",
                    bgcolor: "#fff",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Box sx={{ textAlign: "center", mb: 0.75 }}>
                    <Typography
                      sx={{
                        fontSize: 12,
                        fontWeight: 600,
                        color: "text.secondary",
                      }}
                    >
                      {WEEKDAY_LABELS[cell.date.getDay()]}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: 14,
                        fontWeight: isToday ? 700 : 500,
                        width: 26,
                        height: 26,
                        lineHeight: "26px",
                        borderRadius: "50%",
                        mx: "auto",
                        bgcolor: isToday ? "primary.main" : "transparent",
                        color: isToday ? "#fff" : "text.primary",
                      }}
                    >
                      {cell.date.getDate()}
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 0.4,
                      overflowY: "auto",
                    }}
                  >
                    {events.length === 0 ? (
                      <Typography
                        sx={{
                          fontSize: 11,
                          color: "text.disabled",
                          textAlign: "center",
                          mt: 1,
                        }}
                      >
                        No events
                      </Typography>
                    ) : (
                      events.map((ev, j) => (
                        <Box
                          key={j}
                          onClick={(e) => handleEventClick(e, ev, cell)}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.4,
                            px: 0.4,
                            py: 0.3,
                            borderRadius: 0.5,
                            bgcolor: `${CASE_TYPE_COLORS[ev.type]}1A`,
                            overflow: "hidden",
                            cursor: "pointer",
                          }}
                          title={`${ev.time} - ${ev.title} (${ev.client})`}
                        >
                          <Box
                            sx={{
                              width: 5,
                              height: 5,
                              minWidth: 5,
                              borderRadius: "50%",
                              bgcolor: CASE_TYPE_COLORS[ev.type],
                            }}
                          />
                          <Typography
                            noWrap
                            sx={{
                              fontSize: 12,
                              color: "text.primary",
                              lineHeight: 1.3,
                            }}
                          >
                            {ev.time} {ev.title}
                          </Typography>
                        </Box>
                      ))
                    )}
                  </Box>
                </Box>
              );
            })}
          </Box>
        )}
      </Paper>

      <Popover
        open={Boolean(popoverAnchor)}
        anchorEl={popoverAnchor}
        onClose={handlePopoverClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        {popoverCell && (
          <Box sx={{ p: 1.25, minWidth: 220 }}>
            <Typography sx={{ fontWeight: 600, fontSize: 14, mb: 0.75 }}>
              {popoverCell.cell.date.toLocaleDateString("en-US", {
                weekday: "long",
                day: "2-digit",
                month: "short",
                year: "numeric",
              })}
            </Typography>
            {popoverCell.events.map((ev, i) => (
              <Box
                key={i}
                onClick={(e) => handleEventClick(e, ev, popoverCell.cell)}
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: 0.6,
                  mb: 0.6,
                  cursor: "pointer",
                }}
              >
                <Box
                  sx={{
                    width: 6,
                    height: 6,
                    minWidth: 6,
                    mt: 0.5,
                    borderRadius: "50%",
                    bgcolor: CASE_TYPE_COLORS[ev.type],
                  }}
                />
                <Box>
                  <Typography sx={{ fontSize: 12.5, fontWeight: 600 }}>
                    {ev.time} · {ev.title}
                  </Typography>
                  <Typography sx={{ fontSize: 12, color: "text.secondary" }}>
                    {ev.client} · {ev.type}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
        )}
      </Popover>

      <Dialog
        open={Boolean(selectedEvent)}
        onClose={handleEventDialogClose}
        maxWidth="xs"
        fullWidth
      >
        {selectedEvent && (
          <>
            <DialogTitle
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                fontSize: 16,
                fontWeight: 600,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.75,
                  mb: 1.5,
                }}
              >
                <Box
                  sx={{
                    width: 8,
                    height: 8,
                    minWidth: 8,
                    borderRadius: "50%",
                    bgcolor: CASE_TYPE_COLORS[selectedEvent.type],
                  }}
                />
                <Typography sx={{ fontSize: 13, fontWeight: 600 }}>
                  {selectedEvent.type}
                </Typography>
              </Box>
              <IconButton size="small" onClick={handleEventDialogClose}>
                <CloseIcon fontSize="small" />
              </IconButton>
            </DialogTitle>
            <DialogContent dividers>
              {[
                ["Case No.", selectedEvent.title],
                [
                  "Date",
                  selectedEvent.date?.toLocaleDateString("en-US", {
                    weekday: "long",
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  }),
                ],
                ["Time", selectedEvent.time],
                ["Client", selectedEvent.client],
                ["Respondent", selectedEvent.respondent || "N/A"],
                ["Court", selectedEvent.court || "N/A"],
              ].map(([label, value]) => (
                <Box
                  key={label}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    py: 0.6,
                    borderBottom: "1px solid #F0F1F3",
                  }}
                >
                  <Typography sx={{ fontSize: 12.5, color: "text.secondary" }}>
                    {label}
                  </Typography>
                  <Typography sx={{ fontSize: 12.5, fontWeight: 600 }}>
                    {value}
                  </Typography>
                </Box>
              ))}

              {selectedEvent.description && (
                <Box sx={{ mt: 1.25 }}>
                  <Typography
                    sx={{ fontSize: 12.5, color: "text.secondary", mb: 0.4 }}
                  >
                    Description
                  </Typography>
                  <Typography sx={{ fontSize: 12.5 }}>
                    {selectedEvent.description}
                  </Typography>
                </Box>
              )}
            </DialogContent>
          </>
        )}
      </Dialog>
    </Box>
  );
}
